import ajax from '@/utils/ajax';

export const head = '/web';

// 个人设置账户安全变更手机号
export const reqModifyPhone = (data) => ajax(`${head}/v1/user/safety/modify-phone?phone=${data.phone}`, '', 'PUT');

// 获取课表
export const reqCatalogService = (catalogId) => ajax(`/api/catelog/web/v1/course/catalog/${catalogId}`, '', 'GET');
